import { SearchUpgrade } from './search_upgrade';
import Util from './util';

const win = typeof (window as any) !== 'undefined' ? window : {} as Window;
if (!(win as any).com) { (win as any).com = {}; }
const com = (win as any).com;
if (!com.TI) { com.TI = {}; }


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        if (com && com.TI && com.TI.search && com.TI.search.init && typeof com.TI.search.init === "function") {
            if (!com.TI.search.initCalled) com.TI.search.init();
        }
        SearchUpgrade.initSearchEngine();
    });
}
else {
    if (com && com.TI && com.TI.search && com.TI.search.init && typeof com.TI.search.init === "function") {
        if (!com.TI.search.initCalled) com.TI.search.init();
    }
    SearchUpgrade.initSearchEngine();
}

declare let Context: any;
Context.searchUtil = Util;
